import { render, staticRenderFns } from "./SchoolConfigModal.vue?vue&type=template&id=2616510f&scoped=true"
import script from "./SchoolConfigModal.vue?vue&type=script&lang=js"
export * from "./SchoolConfigModal.vue?vue&type=script&lang=js"
import style0 from "./SchoolConfigModal.vue?vue&type=style&index=0&id=2616510f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616510f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2616510f')) {
      api.createRecord('2616510f', component.options)
    } else {
      api.reload('2616510f', component.options)
    }
    module.hot.accept("./SchoolConfigModal.vue?vue&type=template&id=2616510f&scoped=true", function () {
      api.rerender('2616510f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/model/SchoolConfigModal.vue"
export default component.exports